import { useEffect, useState } from 'react'
import Select from 'react-select'

import { SelectOption, SelectData } from './models'
import { getPaymentAdapterLookup } from '../core/_requests'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'

export const selectType = 'paymentAdapter'

const PaymentAdapterFilter = ({
  changeSelect,
  isMultiple,
  value,
  enabledOnly = true,
}: {
  changeSelect: (selectData: SelectData) => void
  initialFilter?: Array<number>
  isMultiple?: boolean
  value: number[]
  /** false — include disabled adapters (searching historic operations). */
  enabledOnly?: boolean
}) => {
  const { mode: theme } = useThemeMode()
  const [options, setOptions] = useState<Array<SelectOption>>([])
  const [loading, setLoading] = useState(true)

  const updateListPaymentAdapters = async () => {
    const response = await getPaymentAdapterLookup({ enabledOnly })

    if (response.data.success && response.data.data) {
      setOptions(response.data.data)
      setLoading(false)
    }
  }

  useEffect(() => {
    updateListPaymentAdapters()
  }, [])

  const handleChange = (selectedData: any) => {
    const values = !selectedData
      ? []
      : !isMultiple
      ? [selectedData.value]
      : selectedData.map((item: SelectOption) => item.value)

    changeSelect({
      value: values,
      type: selectType,
    })
  }

  return loading ? (
    <>Загрузка адаптеров...</>
  ) : (
    <Select
      value={options.filter((o: SelectOption) => value?.find((sv) => sv === o.value)) || ''}
      onChange={handleChange}
      isClearable={options.some((v) => !v.isFixed)}
      isMulti={isMultiple}
      options={options}
      placeholder={'Выберите платежный адаптер'}
      styles={SelectStyles(theme)}
    />
  )
}

export default PaymentAdapterFilter
